import { gql } from 'graphql-request';


export const COMPANY_PROFILE_FRAGMENT = gql`
    fragment CompanyProfileFields on CompanyProfileOutput {
        profile {
            id
            name
            email
            registrationState
            imageUrl
            pricingAuthority
            authorities
            isEnabled
            department {
                id
                name
            }
            accessControl {
                companyHotelId
                hotelName
                domainAuthorities {
                    domain
                    authority
                }
            }
            
        }
        invitation {
            sentDate
            state
        }
    }
`
export const SIMPLE_COMPANY_PROFILE_FRAGMENT = gql`
    fragment SimpleCompanyProfileFields on CompanyProfileOutput {
        profile {
            id
            name
            email
            registrationState
            imageUrl
            pricingAuthority
            authorities
						isEnabled
        }
    }
`